<template>
  <div id="componente">
    <div class="d-flex">
      <template v-for="(item, _index) in cards">
        <CardTotalizador
          v-model="card_selecionado"
          :filtros_sys_categorias="filtros_sys_categorias"
          :key="_index"
          :card="item"
          class="ml-3 my-3"
          :atualizar_cards_count="atualizar_cards_count"
        />
      </template>
    </div>
  </div>
</template>

<script>
import CardTotalizador from "./CardTotalizador";
import {card_selecionado} from "../Helpers/CardSelecionado";
import {categoria_selecionada} from "@/components/compra/materiaPrima/compra/Helpers/CategoriaSelecionado";
import * as requisicoes from "../../../../../api/compras/MateriaPrima.js";

export default {
  name: "CardsTotalizadores",
  mixins: [card_selecionado, categoria_selecionada],
  components: {
    CardTotalizador
  },
  props: {
    filtros_sys_categorias: Array
  },
  data: () => ({
    atualizar_cards_count: 0,
    cards: [
      {chave: 'itens_a_comprar', titulo: 'Itens a comprar', buscarDados: requisicoes.buscarQtdCategoriasEmGatilhoDeCompra},
      {chave: 'completar_compra', titulo: 'Completar a compra', buscarDados: requisicoes.buscarQtdCategoriasEmCompletarCompra},
      {chave: 'mostrar_todos', titulo: 'Mostrar todos', buscarDados: requisicoes.buscarQtdGeralDeCategorias},
      {chave: 'itens_em_transito', titulo: 'Itens em trânsito', buscarDados: requisicoes.buscarQtdCategoriasEmTransito},
    ]
  }),
  watch: {
    card_selecionado() {
      this.categoria_selecionada = null;
    }
  },
  created() {
    this.card_selecionado = this.cards[0] || {};
    // callback para atualizar cards de qualquerr lugar
    this.$store.dispatch("compraMateriaPrima/callbackAtualizarCardsTotais", this.atualizarCardsTotais);
  },
  methods: {
    atualizarCardsTotais() {
      this.atualizar_cards_count = this.atualizar_cards_count + 1;
    }
  }
}
</script>

<style scoped>
#componente {
  display: flex;
  align-items: center;
  color: #043554;
}
</style>
